import { borderRadiusCommon } from 'components/sharedComponents/StyleConsts/styleConsts';
import { PRIMARY_COLOR, SURFACE_COLOR } from 'constants/colors';
import styled from 'styled-components';

const StyledConformationWindow = styled.div({
  p: {
    color: PRIMARY_COLOR
  },

  '.modal-button': {
    backgroundColor: PRIMARY_COLOR,
    padding: '14px 32px 14px 32px',
    color: SURFACE_COLOR,
    borderRadius: borderRadiusCommon,
    border: 'none',
    marginTop: '32px',
    cursor: 'pointer',
    p: {
      color: SURFACE_COLOR
    }
  },
  '.button-first': {
    marginRight: '5px'
  }
});

export default StyledConformationWindow;
